import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Row, Col, BreadcrumbItem } from 'reactstrap';
import PropTypes from 'prop-types';

const Breadcrumb = ({ breadcrumbItem }) => {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  const formatSegment = (segment) => {
    if (segment.toLowerCase() === 'smsemailreport') {
      return 'Sms Email Report';
    }
    if (segment === 'todayBookingsReport') {
      return 'Today Bookings Report';
    }
    if (segment === 'adminAppointment') {
      return 'Appointment Home';
    }
    if (segment === 'revenuereport') {
      return 'Revenue Report';
    }
    if (segment === 'dashboardlist') {
      return 'Dashboards';
    }
    if (segment === 'locationdashboard') {
      return 'Location Dashboard';
    }
    if (segment === 'businessdashboard') {
      return 'Business Dashboard';
    }
    return segment.charAt(0).toUpperCase() + segment.slice(1).replace(/-/g, ' ');
  };

  return (
    <Row>
      <Col xs="12">
        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
          <h4 className="mb-0 font-size-18">{breadcrumbItem}</h4>
          <div className="page-title-right">
            <ol className="breadcrumb m-0">
              <BreadcrumbItem style={{ textDecorationLine: 'underline', color: '#86aaf9' }}>
                <Link to="/" style={{ color: '#86aaf9' }}>
                  Home
                </Link>
              </BreadcrumbItem>
              {pathSegments.map((segment, index) => {
                const path = `/${pathSegments.slice(0, index + 1).join('/')}`;
                const formattedSegment = formatSegment(segment);
                return index === pathSegments.length - 1 ? (
                  <BreadcrumbItem key={index} active>
                    {formattedSegment}
                  </BreadcrumbItem>
                ) : (
                  <BreadcrumbItem
                    key={index}
                    style={{ textDecorationLine: 'underline', color: '#86aaf9' }}>
                    <Link to={path} style={{ color: '#86aaf9' }}>
                      {formattedSegment}
                    </Link>
                  </BreadcrumbItem>
                );
              })}
            </ol>
          </div>
        </div>
      </Col>
    </Row>
  );
};

Breadcrumb.propTypes = {
  breadcrumbItem: PropTypes.string
};

export default Breadcrumb;
